import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

// 404 — Página no encontrada.
export const NotFoundPage = () => {
  return (
    <div className="bg-bg flex min-h-screen items-center justify-center p-6">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="items-center gap-2">
          <div
            className="bg-surface-2 flex h-16 w-16 items-center justify-center rounded-full"
            aria-hidden="true"
          >
            <Compass className="text-text-muted h-8 w-8" />
          </div>
          <CardTitle className="text-2xl">404 — Página no encontrada</CardTitle>
          <CardDescription>La ruta que buscas no existe o fue movida.</CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          <Button asChild>
            <Link to="/">Volver al inicio</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
